import * as React from 'react';
import { ContextModalProps } from '@mantine/modals';
import { Text, Button, Container, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useDisclosure, useInputState } from '@mantine/hooks';
import { useForm } from '@mantine/form';
import { IconUser } from '@tabler/icons-react';

// Components
import { FormScaffolding, FormScaffoldingProps, FormHandle } from '../../Form/FormScaffolding';
import { TextInput } from '../../Form/components/TextInput';

// Helpers
import { RegExpClass } from '../../../helpers/RegExpClass';

interface ConfirmEmailModalProps {
    onSubmit: (email: string) => Promise<boolean>;
    onCancel: () => void;
    modalBody: string;
}

export const ConfirmEmailModal = ({ context, id, innerProps }: ContextModalProps<ConfirmEmailModalProps>) => {
    const { t } = useTranslation('common');
    const [loading, setLoading] = React.useState(false);
    const form = useForm({
        initialValues: {
            email: ''
        },
        validate: {
            email: (val: string): string | null =>
                Boolean((val ?? '').trim().match(RegExpClass.EMAIL)) ? null : 'Please enter valid email.'
        }
    });

    return (
        <Container p="0">
            <form
                onSubmit={form.onSubmit(async (values) => {
                    setLoading(true);
                    const successful = await innerProps.onSubmit((values.email ?? '').trim().toLowerCase());
                    setLoading(false);
                    context.closeModal(id);
                })}
            >
                <Text mb="lg">{innerProps.modalBody}</Text>
                <TextInput
                    label={t('email', { ns: 'common' })}
                    icon={<IconUser size="1rem" />}
                    placeholder="Enter email"
                    {...form.getInputProps('email')}
                />
                <Group position="right" mt="md">
                    <Button type="submit" disabled={!form.values.email} loading={loading}>
                        {t('logIn', { ns: 'common' })}
                    </Button>
                    {/* <Button
                        fullWidth
                        mt="md"
                        onClick={() => {
                            context.closeModal(id);
                            innerProps.onCancel();
                        }}
                    >
                        <Text transform="capitalize">{t('close')}</Text>
                    </Button> */}
                </Group>
            </form>
        </Container>
    );
};
